import { atom } from 'recoil'

import { type ModalActivateSimulateState } from 'Pages/WorkflowsList/types'

export const modalActivateSimulateState = atom<ModalActivateSimulateState>({
  key: 'workflowsList_modalActivateSimulateState',
  default: {
    idWorkflow: 0,
    mode: 'activate',
    show: false,
    recipientLimit: 0
  }
})
